module.exports = __webpack_public_path__ + "img/bus_grey.b6e30da5.svg";